import {
    ADDRESS_LIST,
    ADDRESS_PAGINATION
} from './constant';

export const initStateFeed = {
    addressList: [],
    pagination: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case ADDRESS_LIST: {
            return {
                ...state,
                addressList: action.payload,
            };
        }
        case ADDRESS_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        case 'RESET_ADDRESS_LIST':
            return {
                ...state,
                addressList: [],
            };
        default:
            return state;
    }
};
